import {Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {NotificationService} from '../../shared/services/notification.service';
import {UserService} from '../../shared/services/user.service';
import {Router} from '@angular/router';
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'mbnm-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

  constructor(private notificationService: NotificationService,
              private userService: UserService,
              @Inject(PLATFORM_ID) private platformId: Object,
              private router: Router) { }

  resetPasswordForm: any = {};
  forgotPasswordForm: any = {};
  authenticationCodeSent = false;
  resendCodeDisableTime = 0;
  counterDownInterval;
  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.counterDownInterval = setInterval(() => {
        this.resendCodeDisableTime--;
        if (this.resendCodeDisableTime < 0) {
          this.resendCodeDisableTime = 0;
        }
      }, 1000);
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.counterDownInterval);
  }

  public async savePasswordChange() {
    if (this.resetPasswordForm.new && this.resetPasswordForm.confirm) {
      if (this.resetPasswordForm.new !== this.resetPasswordForm.confirm) {
        this.notificationService.createNotification('Passwords do not match.', 'error');
      } else if (this.resetPasswordForm.new.length < 6) {
        this.notificationService.createNotification('Passwords must be at least 6 characters long.', 'error');
      } else {
        try {
          await this.userService.resetPassword(this.resetPasswordForm.new ,this.resetPasswordForm.forgotPasswordSecret);
          this.notificationService.createNotification('User password successfully reset.', 'success');
          this.router.navigateByUrl('/account');
        } catch (errorResponse: any) {
          if (errorResponse.error && errorResponse.error.ErrorCode === 'INVALID_SECRET') {
            this.notificationService.createNotification('Authentication code is invalid or expired.', 'error');
          } else {
            this.notificationService.createNotification('There was an error resetting your password.', 'error');
          }
        }
      }
    } else {
      this.notificationService.createNotification('All fields are required to reset your password.', 'error');
    }
  }

  public async sendAuthenticationCode() {
    this.resendCodeDisableTime = 10;

    try {
      await this.userService.forgotPassword(this.forgotPasswordForm.email);
      this.authenticationCodeSent = true;
    } catch (errorResponse: any) {
      this.resendCodeDisableTime = 0;
      this.notificationService.createNotification(errorResponse.error.Message, 'error');
    }
  }

}
